import React from 'react';
import { NavigateFunction } from 'react-router';
import { CellContext } from '@tanstack/react-table';

import AdaptiveTableCell from '@components/common/AdaptiveTableCell';

import { formatCurrency } from '@utils/formatter';

import { IDashboardRentsGeneralSummary } from '@interfaces/platform/platformDashboard';

import { routes } from '@constants/routes';
import { columnSizes } from '@constants/table';

import ViewOrganisationTableCell from '../ViewOrganizationTableCell';

const { adminPanel: { index, organisations } } = routes;

export const getRequestsColumns = ({ navigate }: { navigate: NavigateFunction }) =>
	([
		{
			header: 'Organisation',
			accessorKey: 'organization',
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();
				const { name, id, avatar } = value || {};

				const openOrganisationProfile = () => {
					if (!id) return;

					navigate(`${index}${organisations}/organisation-profile/${id}`);
				};

				return (
					<ViewOrganisationTableCell
						avatarId={avatar?.id}
						onClick={openOrganisationProfile}
						text={name}
						tooltipLabel='Company profile'
					/>
				);
			},
		},
		{
			header: 'Requests completed',
			accessorKey: 'completedRequest',
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						isCentered
						text={value}
					/>
				);
			},
		},
		{
			header: 'Assets requested',
			accessorKey: 'requestedAssets',
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						isCentered
						text={value}
					/>
				);
			},
		},
		{
			header: 'Assets arranged',
			accessorKey: 'arrangedAssets',
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();

				return (
					<AdaptiveTableCell
						isCentered
						text={value}
					/>
				);
			},
		},
		{
			header: 'Total cost arranged (£)',
			accessorKey: 'arrangedTotalCost',
			size: columnSizes.size88,
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();
				const currency = formatCurrency(value);

				return (
					<AdaptiveTableCell
						isCentered
						text={currency}
					/>
				);
			},
		},
		{
			header: 'Platform earned (£)',
			accessorKey: 'poEarned',
			size: columnSizes.size88,
			cell: ({ getValue }: CellContext<IDashboardRentsGeneralSummary, any>) => {
				const value = getValue();
				const currency = formatCurrency(value);

				return (
					<AdaptiveTableCell
						isCentered
						text={currency}
					/>
				);
			},
		},
	]);
